import { render, staticRenderFns } from "./index_bak.vue?vue&type=template&id=ed958076&scoped=true&"
import script from "./index_bak.vue?vue&type=script&lang=js&"
export * from "./index_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed958076",
  null
  
)

export default component.exports